import { Form } from 'factorial-form'

class LocationForm extends Form {
  constructor(values: {}) {
    super(values, {
      address_line_1: 'string',
      address_line_2: 'string',
      city: 'string',
      country: 'string',
      name: 'string',
      phone_number: 'string',
      postal_code: 'string',
      state: 'string',
      timezone: 'string',
    })
  }
}

export default LocationForm
